class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  translations = {
    'NL': 'Resterend bedrag tot gratis verzending: ',
    'ES': 'Cantidad restante para envío gratuito: ',
    'DE': 'Verbleibender Betrag für kostenlosen Versand: ',
    'EN': 'Remaining amount for free shipping: '
  };

  translationsFreeshipping = {
  'NL': 'Gratis verzending',
  'ES': 'Envío gratuito',
  'DE': 'Kostenloser Versand',
  'EN': 'Free shipping'
};

  countryCode = 'NL';
  remainingAmount = 60;
  freeShippingThreshold = 60;
  totalPrice = 0;
  
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.initProgressBar();
  }

  cartUpdateUnsubscriber = undefined;
  
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    this.initProgressBar();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }
  
updateProgressBar() {
    let remainingAmountText = '';

    if (this.remainingAmount <= 0) {
        const translation = this.translationsFreeshipping[this.countryCode] || this.translationsFreeshipping['EN'];
        remainingAmountText = translation;
    } else {
        const translation = this.translations[this.countryCode] || this.translations['EN'];
        remainingAmountText = `${translation}${window.currency}${this.remainingAmount.toFixed(2)}`;
    }

    document.getElementById('remaining-amount').innerHTML = "<p>" + remainingAmountText + "</p>";

    const progressBar = document.getElementById('progress-bar');
    const progress = (this.totalPrice / this.freeShippingThreshold) * 100;
    progressBar.style.width = progress + '%';
}


  initProgressBar() {
    this.fetchCountryAndThreshold();
  }

  onChangeTotalPrice() {
    var totalPriceString = document.getElementById('total_cart').innerHTML;
    var totalPriceParsed = totalPriceString.replace(/[^0-9.,]/g, '');
    this.totalPrice = parseFloat(totalPriceParsed);
    
    this.remainingAmount = this.freeShippingThreshold - this.totalPrice;
    if (this.remainingAmount < 0) {
        this.remainingAmount = 0;
    }
  }
  fetchCountryAndThreshold() {
    const API_KEY = '6kAQdH5LfUiiuxsIlnqdKSvgWGQiyuTocL6BOSceiyJ45wk7I9';
    const url = `https://ipapi.co/json/?key=${API_KEY}`;
    fetch(url)
        .then(response => response.json())
        .then(data => {
            this.countryCode = data.country_code;
            const countriesWithLowerThreshold = [
                'AU', 'NZ', 'BH', 'TW', 'AL', 'BG', 'HK', 'IS', 'ID', 'JP', 'MY', 'MX', 'SG', 'KR', 'TH', 'AE',
                'BD', 'BT', 'IO', 'BN', 'KH', 'CN', 'CX', 'CC', 'PH', 'IQ', 'YE', 'JO', 'KW', 'LA', 'LB', 'MO',
                'MV', 'MN', 'MM', 'NP', 'OM', 'PK', 'QA', 'SA', 'LK', 'TM', 'VN', 'AX', 'AD', 'BA', 'FO', 'GI',
                'GL', 'GP', 'GG', 'IM', 'JE', 'XK', 'LI', 'YT', 'MC', 'ME', 'MK', 'RE', 'SM', 'RS', 'SJ', 'VA',
                'EG', 'MA', 'ZA', 'AI', 'AG', 'AW', 'BS', 'BB', 'BZ', 'BM', 'VG', 'CR', 'CW', 'DM', 'DO', 'SV',
                'GD', 'GT', 'HT', 'HN', 'JM', 'KY', 'UM', 'MQ', 'MS', 'NI', 'PA', 'KN', 'LC', 'VC', 'BL', 'MF',
                'PM', 'SX', 'TT', 'TC', 'AR', 'BO', 'BQ', 'CL', 'CO', 'EC', 'FK', 'GF', 'GY', 'PY', 'PE', 'SR',
                'UY', 'VE', 'CK', 'FJ', 'PF', 'KI', 'NR', 'NC', 'NU', 'NF', 'TL', 'PG', 'PN', 'SB', 'WS', 'TK',
                'TO', 'TV', 'VU', 'WF', 'TF', 'GS', 'TR', 'IL'
            ];

            if (countriesWithLowerThreshold.includes(this.countryCode)) {
                this.freeShippingThreshold = 150;
            } else {
                this.freeShippingThreshold = 60;
            }
        })
        .catch(error => console.error('Error fetching country code:', error))
        .finally(() => {
            this.onChangeTotalPrice();
            this.updateProgressBar();
        });
}


  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    try {
      document.querySelector('button[name="checkout"]').setAttribute("disabled", "");//.style.pointerEvents = "none";
      setTimeout(() => {
        document.querySelector('button[name="checkout"]').removeAttribute("disabled");//.style.pointerEvents = "auto";
      }, 3800)
    } catch (e) {}
      
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        this.onChangeTotalPrice();
        this.updateProgressBar();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
